import { all, call, takeLatest } from "redux-saga/effects";

import { INITIATE_MAIN_LOOP } from "../../actions/controllers/main";
import { fetchLocales } from "./fetchLocales";

export function* watchRunMainInit() {
  yield takeLatest(INITIATE_MAIN_LOOP, startMainLoop);
}

function* startMainLoop(action) {
  // Fetch banks, countries, genders, titles and user_types async
  yield all([call(fetchLocales)]);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/controllers/main.js